import { Box, useTheme } from "@mui/material";
import { Bar, Line } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {Chart, BarElement} from 'chart.js';
import { useTranslation } from "react-i18next";

Chart.register(BarElement);

export default function HistoryChart({history}) {
    const theme = useTheme()
    const { t } = useTranslation()

    const ranks = history.map(el => el["r"]);

    const options = {
        layout: {
            padding: {
                top: 0, // Adjust this value to add more or less padding to the top
                right: 15,
                bottom: 0,
                left: 15
            }
        },
        responsive: true,
        aspectRatio: 2,
        plugins: {
            legend: {
            display: false,
            position: "bottom"
            },
            tooltip: {
                enabled: false,
            },
            datalabels: {
                align: 'end',
                anchor: 'end',
                font: {
                    weight: 'bold',
                    size: 10,
                },
                offset: -2,
                formatter: (value, context) => value !== null ? "P" + value : "",
            }
        },
        interaction: {
            intersect: false,
            mode: 'index',
        },
        scales: {
            y: {
                maxRotation: 0,
                display: false,
                min: 0,
                max: Math.max(...ranks.filter(el => el !== null)) + 200,
            },
            x: {
            grid: {
                display: true,
            },
            //ticks: {
            //  maxRotation: 0
            //}
            }
        },
        };
        
    const chartData = {
        labels: history.map(el => el["l"]),
        datasets: [
        {
            label: t("userCard.chartLabel"),
            data: ranks,
            backgroundColor: history.map(el => el["p"] ? "#ddb0ff" : theme.palette.primary.main),
            borderColor: theme.palette.primary.main,
            borderRadius: 5,
            datalabels: {
              color: history.map(el => el["p"] ? '#ddb0ff' : theme.palette.primary.main),
            }
        },
        ],
    
    };
            
    return <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", pt: 2, pb: 1, width: "100%"}}>
        <Bar options={options} data={chartData} plugins={[ChartDataLabels]} />
    </Box>;
}